/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetNetworkIngressDeleteImpactSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetNetworkIngressDeleteImpactRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetNetworkIngressDeleteImpactSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetNetworkIngressDeleteImpactSecurity$outboundSchema:
  z.ZodMiniType<
    GetNetworkIngressDeleteImpactSecurity$Outbound,
    GetNetworkIngressDeleteImpactSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getNetworkIngressDeleteImpactSecurityToJSON(
  getNetworkIngressDeleteImpactSecurity: GetNetworkIngressDeleteImpactSecurity,
): string {
  return JSON.stringify(
    GetNetworkIngressDeleteImpactSecurity$outboundSchema.parse(
      getNetworkIngressDeleteImpactSecurity,
    ),
  );
}

/** @internal */
export type GetNetworkIngressDeleteImpactRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetNetworkIngressDeleteImpactRequest$outboundSchema: z.ZodMiniType<
  GetNetworkIngressDeleteImpactRequest$Outbound,
  GetNetworkIngressDeleteImpactRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getNetworkIngressDeleteImpactRequestToJSON(
  getNetworkIngressDeleteImpactRequest: GetNetworkIngressDeleteImpactRequest,
): string {
  return JSON.stringify(
    GetNetworkIngressDeleteImpactRequest$outboundSchema.parse(
      getNetworkIngressDeleteImpactRequest,
    ),
  );
}
